exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".preferences-ct {\n  padding: 0;\n  position: relative;\n  margin-bottom: 1rem;\n  width: 100%; }\n\n.view-heading {\n  font-size: 1.4rem; }\n\n.preferences {\n  position: relative;\n  width: 90%;\n  margin: 1rem; }\n  .preferences .btn-link {\n    color: black; }\n\n.preferences-body {\n  width: 100%;\n  padding: 1rem 0 0 1rem; }\n\n.emailauth-preferences-body {\n  width: 100%;\n  height: 3rem;\n  padding: 1rem 0 0; }\n\n.redeem-preferences-body {\n  width: 100%;\n  height: 3rem; }\n\ndiv.preferences-print {\n  float: right;\n  margin-right: .25rem; }\n", ""]);

// exports
